export const getDomainConfig = () => {
  let config = {};
  const domainUrl = window.location.hostname;
  if (domainUrl.match(/americanattractions|aa/)) {
    config = {
      termsLink: "terms_conditions&ids=339132",
      policyLink: "privacy_policy&ids=339133",
      siteName: "American Attractions",
      logo: "/sites/all/themes/AA2/images/logo-d.svg",
      brand: "Aa",
      favicon: "/sites/default/files/domain-2/AA2_favicon.ico",
      apiBaseUrl: (process.env.REACT_APP_AA_BASE_API_URL) ? process.env.REACT_APP_AA_BASE_API_URL : "",
      checkoutCompleteBaseUrl: "",
      allowMarketing: true,
      paypalScript: "https://www.paypal.com/sdk/js?client-id=AXeMsiPRoEPqW1QNQlCNrP-H-q2QWSHZYLjC2oH4dQiqcFGFlT2wd2sIXcXCby9tEI0MG9nE9_d9wmdA&components=messages",
      externalPayLabel:"American Attractions",
    };
  } else if (domainUrl.match(/seaworldparks|sw|seaworld/)) {
    config = {
      termsLink: 'booking_conditions',
      policyLink: 'privacy_policy',
      siteName: "SeaWorld Parks UK",
      logo: "/images/sw/seaworld-parks-and-entertainment.svg",
      brand: "Sw",
      favicon: "/sites/all/themes/seaworldtheme/favicon.ico",
      apiBaseUrl: (process.env.REACT_APP_SW_BASE_API_URL) ? process.env.REACT_APP_SW_BASE_API_URL : "",
      checkoutCompleteBaseUrl: "",
      allowMarketing: true,
      paypalScript: "",
      externalPayLabel:"SeaWorld Parks & Entertainment",
    };
  } else if (domainUrl.match(/universal-bookings|uo|orlando|universal|uwl/)) {
    config = {
      termsLink: 'terms_conditions',
      policyLink: 'privacy_policy',
      siteName: "Universal Bookings",
      logo: "",
      brand: "Uo",
      favicon: "/sites/all/themes/UO/favicon.ico",
      apiBaseUrl: (process.env.REACT_APP_UO_BASE_API_URL) ? process.env.REACT_APP_UO_BASE_API_URL : "",
      checkoutCompleteBaseUrl: "",
      allowMarketing: false,
      paypalScript: "https://www.paypal.com/sdk/js?client-id=AXeMsiPRoEPqW1QNQlCNrP-H-q2QWSHZYLjC2oH4dQiqcFGFlT2wd2sIXcXCby9tEI0MG9nE9_d9wmdA&components=messages",
      externalPayLabel:"Universal Studios",
    };
  } else if (domainUrl.match(/attractiontickets|global|localhost/)) {
    config = {
      termsLink: '4239',
      policyLink: '4240',
      siteName: "AttractionTickets",
      logo: "https://www.attractiontickets.com/themes/custom/atd/images/at.svg",
      brand: "Atd",
      favicon: "/themes/custom/atd/favicons/favicon.ico",
      apiBaseUrl: (process.env.REACT_APP_GLOBAL_BASE_API_URL) ? process.env.REACT_APP_GLOBAL_BASE_API_URL : "",
      checkoutCompleteBaseUrl: "",
      allowMarketing: true,
      paypalScript: "https://www.paypal.com/sdk/js?client-id=AXeMsiPRoEPqW1QNQlCNrP-H-q2QWSHZYLjC2oH4dQiqcFGFlT2wd2sIXcXCby9tEI0MG9nE9_d9wmdA&components=messages",
      externalPayLabel:"Attractiontickets.com",
    };
  } else {
     config = {
      termsLink: 'terms_conditions',
      policyLink: 'privacy_policy',
      siteName: "Universal Bookings",
      logo: "",
      brand: "Uo",
      favicon: "/sites/all/themes/UO/favicon.ico",
      apiBaseUrl: (process.env.REACT_APP_UO_BASE_API_URL) ? process.env.REACT_APP_UO_BASE_API_URL : "",
      checkoutCompleteBaseUrl: "",
      allowMarketing: false,
      paypalScript: "https://www.paypal.com/sdk/js?client-id=AXeMsiPRoEPqW1QNQlCNrP-H-q2QWSHZYLjC2oH4dQiqcFGFlT2wd2sIXcXCby9tEI0MG9nE9_d9wmdA&components=messages",
    };
  }
  return config;
};
